const { escapeHtml } = require('./sanitize')
const NON_HTML_REGEX = /^[^<>;]*$/ // regex to not include <, > and ;

const isSafe = (text) => {
  return (
    escapeHtml(
      text,
      {},
      {
        allowAmpersand: true,
        allowDoubleQuotes: true
      }
    ) === text && NON_HTML_REGEX.test(text)
  )
}

const hasHtmlTags = (text) => {
  return !!text.match(/<[^\s]([^>]+)>/g)
}

module.exports = {
  isSafe,
  hasHtmlTags
}
